var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, css } from 'lit';
import { customElement, property, state, query, queryAssignedNodes, } from 'lit/decorators.js';
import cx from 'classnames';
import './toolbar-dropdown.js';
import { getHostKeyText } from './utils.js';
import { computePopPosition } from './pop.js';
import * as zIndex from './zIndex.js';
const dropIcon = html `<svg viewBox="0 0 156 256" fill="currentColor">
  <path
    d="M90.26 180.118l36.906-58.304c6.315-9.963-1.579-22.422-14.208-22.422h-73.813c-12.63 0-20.502 12.459-14.208 22.422l36.928 58.304c6.293 9.962 22.080 9.962 28.394 0z"
  ></path>
</svg>`;
const computeTrueEdge = (element) => {
    Object.assign(element.style, {
        display: 'block',
        top: 'var(--exeditor-edge-bottom, 0px)',
        left: 'var(--exeditor-edge-right, 0px)',
        height: 'var(--exeditor-edge-top, 0px)',
        width: 'var(--exeditor-edge-left, 0px)',
    });
    const rect = element.getBoundingClientRect();
    element.style.setProperty('display', 'none');
    return rect;
};
const arrowIcon = html `
  <svg width="7" height="12">
    <path
      fill="#666"
      fill-rule="evenodd"
      d="M6.067 5.855 1.069.854a.5.5 0 0 0-.707 0 .504.504 0 0 0-.006.713l4.64 4.644-4.64 4.644a.501.501 0 0 0 0 .708c.18.18.449.2.644.064l.069-.058 4.998-5.002a.5.5 0 0 0 .144-.31v-.09a.5.5 0 0 0-.144-.312Z"
    />
  </svg>
`;
const styles = css `
  :host {
    display: inline-block;
    position: relative;
    --button-width: var(--exeditor-toolbar-button-width, 30px);
    --button-height: var(--exeditor-toolbar-button-height, 30px);
    font-size: var(--exeditor-toolbar-button-font-size, 14px);
  }
  :host([in='dropdown']) {
    display: block;
  }

  .button-wrapper {
    display: contents;
  }
  .btn,
  .drop-btn {
    box-sizing: border-box;
    display: block;
    margin: 0;
    padding: 3px;
    height: var(--button-height, 30px);
    border: 0 none;
    background: none;
    cursor: pointer;
    color: currentColor;
    font-size: inherit;
    transition: all 100ms ease;
  }
  .btn {
    min-width: var(--button-width, 30px);
  }
  .drop-btn,
  .btn.in-static {
    border-radius: 4px;
    border: 1px solid transparent;
  }
  .drop-btn:hover,
  .btn.in-static:hover,
  .btn.in-static.open-dropdown,
  .button-wrapper.open-dropdown > .drop-btn,
  .button-wrapper.open-dropdown > .btn.in-static,
  .button-wrapper.separate:hover > .drop-btn,
  .button-wrapper.separate:hover > .btn.in-static {
    border-color: #e7e7e7;
  }
  .btn.in-static.active,
  .button-wrapper.separate.active > .drop-btn,
  .button-wrapper.separate.active > .btn.in-static {
    color: var(--exeditor-toolbar-button-active-color, currentColor);
    border-color: var(--exeditor-toolbar-button-active-border-color, #e7e7e7);
    background-color: var(--exeditor-toolbar-button-active-bg-color, #f0f0f0);
  }
  .drop-btn:disabled,
  .btn.in-static:disabled {
    color: #ccc;
    border-color: transparent;
    cursor: default;
  }
  .btn.in-dropdown {
    display: flex;
    width: 100%;
    height: calc(var(--button-height, 30px) + 6px);
    padding: 11px 16px;
    justify-content: space-between;
    align-items: center;
  }
  .btn.in-dropdown:hover,
  .btn.in-dropdown.open-dropdown {
    background-color: var(
      --exeditor-toolbar-button-in-dropdpwn-hover-color,
      #f0f0f0
    );
  }
  .btn.in-dropdown.active {
    font-weight: bold;
    color: var(--exeditor-toolbar-button-active-color, currentColor);
  }
  .btn.in-dropdown:disabled {
    color: #ccc;
    background-color: transparent;
    cursor: default;
  }

  .button-wrapper.separate {
    display: flex;
  }
  .button-wrapper.separate > .btn.in-static {
    border-radius: 4px 0 0 4px;
  }
  .drop-btn {
    display: flex;
    align-items: center;
    width: 15px;
    padding: 3px 3px;
    border-left: 0 none;
    border-radius: 0 4px 4px 0;
  }
  .drop-btn svg {
    width: 100%;
  }

  .tooltip {
    z-index: ${zIndex.tooltip};
    position: absolute;
    display: none;
    padding: 5px 10px;
    background-color: var(--exeditor-toolbar-tolltip-background-color, #404040);
    border-radius: 4px;
    width: max-content;
    color: white;
    font-size: 12px;
    line-height: 1.5;
    visibility: hidden;
  }
  .tooltip.show {
    display: block;
  }
  .tooltip > .arrow {
    position: absolute;
    width: 0;
    height: 0;
    border: 4px solid var(--exeditor-toolbar-tolltip-background-color, #404040);
  }
  .tooltip.top > .arrow {
    left: 50%;
    bottom: -4px;
    margin-left: -4px;
    border-left-color: transparent;
    border-right-color: transparent;
    border-bottom: none;
  }
  .tooltip.bottom > .arrow {
    left: 50%;
    top: -4px;
    margin-left: -4px;
    border-left-color: transparent;
    border-right-color: transparent;
    border-top: none;
  }
  .tooltip.left > .arrow {
    right: -4px;
    top: 50%;
    margin-top: -4px;
    border-top-color: transparent;
    border-bottom-color: transparent;
    border-right: none;
  }
  .tooltip.right > .arrow {
    left: -4px;
    top: 50%;
    margin-top: -4px;
    border-top-color: transparent;
    border-bottom-color: transparent;
    border-left: none;
  }
  .fake {
    display: none;
    position: fixed;
    visibility: hidden;
  }
  .dropdown[hidden] {
    display: none;
  }
  .dropdown.overflowScroll {
    overflow: auto;
  }

  .icon {
    min-width: var(--button-width, 30px);
  }
  .icon > svg {
    fill: currentColor;
  }

  .text {
    width: fit-content;
    white-space: nowrap;
  }

  .btn.in-dropdown .text {
    flex-grow: 1;
    text-align: left;
  }

  .arrowIcon {
    margin-left: 15px;
  }

  :host([in='dropdown']) .button-wrapper {
    display: block;
  }
  :host([in='dropdown']) .icon {
    display: block;
    min-width: calc(var(--button-height, 30px) - 8px);
    height: calc(var(--button-height, 30px) - 8px);
    margin-right: 12px;
  }
`;
let ExEditorToolbarButtonElement = class ExEditorToolbarButtonElement extends LitElement {
    constructor() {
        super(...arguments);
        this.active = false;
        this.disabled = false;
        this.in = '';
        this.separateDropdown = false;
        this.label = '';
        this.shortcut = '';
        this.scrollOverflowPopContent = false;
        this.isTooltipShow = false;
        this.isDropdownOpen = false;
        this.tooltipPlacement = 'top';
        this.handledClicks = new WeakSet();
        this.addWindowListener = () => {
            window.addEventListener('click', this.handleGlobalClick, false);
        };
        this.removeWindowListener = () => {
            window.removeEventListener('click', this.handleGlobalClick, false);
        };
        this.handleGlobalClick = (e) => {
            if (this.handledClicks.has(e)) {
                this.handledClicks.delete(e);
                return;
            }
            this.closeDropdown();
        };
    }
    closeDropdown() {
        this.toggleDropdown(false);
    }
    openDropdown() {
        this.toggleDropdown(true);
    }
    toggleDropdown(toShow) {
        if (toShow) {
            this.isDropdownOpen = true;
            if (this.tooltipPlacement === 'bottom') {
                this.isTooltipShow = false;
            }
            this.addWindowListener();
        }
        else {
            this.isDropdownOpen = false;
            this.removeWindowListener();
        }
        const event = new CustomEvent('dropdowntoggle', {
            detail: {
                value: toShow,
            },
        });
        this.dispatchEvent(event);
    }
    showTooltip() {
        const edge = computeTrueEdge(this.fakeElement);
        const pos = computePopPosition({
            target: this.tooltipElement,
            ref: this.button,
            placement: this.in !== 'dropdown' ? 'top' : 'left',
            gap: 8,
            alignment: 'center',
            pad: {
                top: edge.height,
                left: edge.width,
                bottom: edge.y,
                right: edge.x,
            },
        });
        const isConflict = this.tooltipPlacement === pos.placement ||
            (this.in === 'dropdown' && pos.placement === 'right') ||
            (this.in !== 'dropdown' && pos.placement === 'bottom');
        if (isConflict && this.isDropdownOpen) {
            this.handleHideShowTooltip();
        }
        else {
            this.tooltipPlacement = pos.placement;
            Object.assign(this.tooltipElement.style, {
                top: `${pos.y}px`,
                left: `${pos.x}px`,
                visibility: 'visible',
            });
            Object.assign(this.tooltipArrowElement.style, {
                transform: `translate(${pos.delta.x}px, ${pos.delta.y}px)`,
            });
        }
    }
    handleBtnClick(e) {
        var _a;
        if (this.disabled || this.handledClicks.has(e)) {
            return;
        }
        this.handledClicks.add(e);
        if (!this.separateDropdown) {
            if ((_a = this.popContent) === null || _a === void 0 ? void 0 : _a.length) {
                this.toggleDropdown(!this.isDropdownOpen);
            }
        }
        else {
            const event = new CustomEvent('buttonclick');
            this.dispatchEvent(event);
        }
    }
    handleDropdownBtnClick(e) {
        e.preventDefault();
        if (this.disabled) {
            return;
        }
        this.handledClicks.add(e);
        this.toggleDropdown(!this.isDropdownOpen);
    }
    handleDropdownClick(e) {
        this.handledClicks.add(e);
    }
    handleShowTooltip() {
        this.isTooltipShow = true;
    }
    handleHideShowTooltip() {
        this.isTooltipShow = false;
        if (this.tooltipElement) {
            this.tooltipElement.style.visibility = 'hidden';
        }
    }
    handleMouseDown(e) {
        e.preventDefault();
    }
    updated() {
        if (this.popContent.length && this.isDropdownOpen) {
            const gap = 5;
            const config = {
                target: this.dropdown,
                ref: this.button,
                placement: this.in === 'dropdown' ? 'right' : 'bottom',
                gap: this.in === 'dropdown' ? gap : 0,
            };
            const pos = computePopPosition(config);
            Object.assign(this.dropdown.style, {
                top: `${pos.y}px`,
                left: `${pos.x}px`,
            }, this.scrollOverflowPopContent
                ? {
                    maxHeight: this.in === 'dropdown'
                        ? `${window.innerHeight - gap}px`
                        : `${pos.availableSize - gap}px`,
                }
                : {});
        }
        if (this.tooltipElement && this.isTooltipShow) {
            setTimeout(() => this.showTooltip());
        }
    }
    render() {
        let text = '';
        let tooltip = '';
        const shortcut = this.shortcut ? getHostKeyText(this.shortcut) : '';
        if (this.in === 'dropdown') {
            text = this.label;
            tooltip = shortcut;
        }
        else {
            tooltip = this.label;
            if (shortcut) {
                tooltip += `(${shortcut})`;
            }
        }
        const showSeparate = this.separateDropdown && this.in !== 'dropdown';
        // mouseenter/mouseleave 无法在 disabled button 上触发，所以需要 .button-wrapper
        return html `
      <span
        class="${cx('button-wrapper', {
            active: this.active,
            'open-dropdown': this.isDropdownOpen,
            separate: showSeparate,
        })}"
        @mouseenter=${this.handleShowTooltip}
        @mouseleave=${this.handleHideShowTooltip}
      >
        <button
          class="${cx('btn', `in-${this.in || 'static'}`, {
            active: this.active,
            'open-dropdown': this.isDropdownOpen,
            separate: showSeparate,
        })}"
          ?disabled=${this.disabled}
          aria-label=${this.label}
          @click=${this.handleBtnClick}
          @focus=${this.handleShowTooltip}
          @blur=${this.handleHideShowTooltip}
          @mousedown=${this.handleMouseDown}
        >
          <slot class="icon"></slot>
          ${this.in === 'dropdown'
            ? html `<span class="text">${text}</span>`
            : null}
          ${this.in === 'dropdown' && this.popContent.length
            ? html `<span class="arrowIcon">${arrowIcon}</span>`
            : null}
        </button>

        ${showSeparate
            ? html `<button
              class="drop-btn"
              ?disabled=${this.disabled}
              @click=${this.handleDropdownBtnClick}
              @mousedown=${this.handleMouseDown}
            >
              ${dropIcon}
            </button>`
            : null}
      </span>

      ${tooltip
            ? html `
            <div
              class="${cx('tooltip', this.tooltipPlacement, {
                show: this.isTooltipShow,
            })}"
            >
              ${tooltip}
              <span class="arrow"></span>
            </div>
          `
            : null}

      <exeditor-toolbar-dropdown
        ?hidden=${!this.isDropdownOpen || !this.popContent.length}
        class="${cx('dropdown', this.scrollOverflowPopContent && 'overflowScroll')}"
        @click=${this.handleDropdownClick}
      >
        <slot
          name="pop-content"
          @slotchange=${() => this.requestUpdate()}
        ></slot>
      </exeditor-toolbar-dropdown>

      <div class="fake"></div>
    `;
    }
};
ExEditorToolbarButtonElement.styles = styles;
__decorate([
    property({
        type: Boolean,
        reflect: true,
    })
], ExEditorToolbarButtonElement.prototype, "active", void 0);
__decorate([
    property({
        type: Boolean,
        reflect: true,
    })
], ExEditorToolbarButtonElement.prototype, "disabled", void 0);
__decorate([
    property({ reflect: true })
], ExEditorToolbarButtonElement.prototype, "in", void 0);
__decorate([
    property({ type: Boolean, reflect: true })
], ExEditorToolbarButtonElement.prototype, "separateDropdown", void 0);
__decorate([
    property({ reflect: true })
], ExEditorToolbarButtonElement.prototype, "label", void 0);
__decorate([
    property({ reflect: true })
], ExEditorToolbarButtonElement.prototype, "shortcut", void 0);
__decorate([
    property({ type: Boolean, reflect: true })
], ExEditorToolbarButtonElement.prototype, "scrollOverflowPopContent", void 0);
__decorate([
    query('.btn')
], ExEditorToolbarButtonElement.prototype, "button", void 0);
__decorate([
    query('.fake')
], ExEditorToolbarButtonElement.prototype, "fakeElement", void 0);
__decorate([
    query('.tooltip')
], ExEditorToolbarButtonElement.prototype, "tooltipElement", void 0);
__decorate([
    query('.tooltip > .arrow')
], ExEditorToolbarButtonElement.prototype, "tooltipArrowElement", void 0);
__decorate([
    query('.dropdown')
], ExEditorToolbarButtonElement.prototype, "dropdown", void 0);
__decorate([
    queryAssignedNodes({ slot: 'pop-content' })
], ExEditorToolbarButtonElement.prototype, "popContent", void 0);
__decorate([
    state()
], ExEditorToolbarButtonElement.prototype, "isTooltipShow", void 0);
__decorate([
    state()
], ExEditorToolbarButtonElement.prototype, "isDropdownOpen", void 0);
__decorate([
    state()
], ExEditorToolbarButtonElement.prototype, "tooltipPlacement", void 0);
ExEditorToolbarButtonElement = __decorate([
    customElement('exeditor-toolbar-button')
], ExEditorToolbarButtonElement);
export { ExEditorToolbarButtonElement };
export function createButton(config, ...children) {
    const btn = Object.assign(document.createElement('exeditor-toolbar-button'), config);
    btn.append(...children);
    return btn;
}
//# sourceMappingURL=toolbar-button.js.map